import getPosition from "../utils/get-position";

export default class {
	constructor() {
		this.header = document.querySelector("header.site-header");

		if (!this.header) {
			return;
		}

		this.siteInner = document.querySelector(".site-inner");
		this.adminbar = document.getElementById("wpadminbar");

		this.isSticky = false;

		window.addEventListener("load", this.init.bind(this));
	}

	init() {
		this.calculateOffset();
		this.handleScroll();

		window.addEventListener("scroll", this.handleScroll.bind(this));
		window.addEventListener("resize", this.handleResize.bind(this));
	}

	calculateOffset() {
		this.offsetTop = getPosition(this.header).y;

		if (this.adminbar) {
			const adminbarStyle = window.getComputedStyle(this.adminbar);

			if ("fixed" !== adminbarStyle.position) {
				this.offsetTop += parseInt(adminbarStyle.height);
			}
		}
	}

	handleScroll() {
		if (window.scrollY > this.offsetTop && !this.isSticky) {
			this.makeSticky();
		} else if (window.scrollY <= this.offsetTop && this.isSticky) {
			this.makeStatic();
		}
	}

	handleResize() {
		if (this.isSticky) {
			this.makeStatic();
		}

		this.calculateOffset();
		this.handleScroll();
	}

	makeSticky() {
		this.header.classList.add("is-sticky");
		this.siteInner.style.paddingTop = `${this.header.clientHeight}px`;
		this.isSticky = true;
	}

	makeStatic() {
		this.header.classList.remove("is-sticky");
		this.siteInner.style.paddingTop = "";
		this.isSticky = false;
	}
}
